module.exports = __webpack_public_path__ + "static/media/README.47d63cf0.md";